export function getFormattedInvestorNamesIntoLine(names: string[]): string {
  let namesAsFormatedString = '';

  for (const name of names) {
    namesAsFormatedString += `<br> ${name}`;
  }

  return namesAsFormatedString;
}
